import React from 'react';
import './cookie_banner.css';

const DISMISS_COOKIE = 'cookie_banner';
const ACCEPT_COOKIE = 'accept_cookie_policy';

class CookieBanner extends React.Component {
  constructor() {
    super();

    this.state = {
      show: !(
        parseInt(CookieBanner.getCookie(DISMISS_COOKIE), 10) || parseInt(CookieBanner.getCookie(ACCEPT_COOKIE), 10)
      ),
    };
  }

  /**
   * Retrieve the cookie name
   * @param {string} cookieName
   * @returns {string}
   */
  static getCookie(cookieName) {
    const b = document.cookie.match(`(^|;)\\s*${cookieName}\\s*=\\s*([^;]+)`);
    return b ? b.pop() : '';
  }

  static setCookie(cookieName, cookieValue) {
    // only allow gosearch.ai or gosearch.io, gosearch.com or gosearch.dev
    const [domain] = window.location.host.match(/(gosearch.(com|dev|io|ai))$/g) || ['gosearch.ai'];
    document.cookie = `${cookieName}=${cookieValue}; expires=Tue, 19 Jan 2038 03:14:07 UTC; path=/; domain=${domain}; secure`;
  }

  /**
   * Dismisses the modal
   */
  handleDismiss() {
    this.setState({ show: false });
    CookieBanner.setCookie(DISMISS_COOKIE, 1);
  }

  /**
   * Dismisses the modal
   */
  handleAccept() {
    this.setState({ show: false });
    CookieBanner.setCookie(ACCEPT_COOKIE, 1);
  }

  isIOS() {
    try {
      const url = new URL(window.location);
      return url?.searchParams?.get('device_type')?.toLowerCase() === 'ios';
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return false;
    }
  }

  render() {
    // Hide on iOS login
    if (this.isIOS()) return null;

    if (this.state.show) {
      return (
        <div className="CookieBanner-container text-center align-middle shadow m-0 p-1">
          <button
            type="button"
            tabIndex="0"
            className="CookieBanner-dismiss CookieBanner-item mr-2"
            onClick={() => {
              this.handleDismiss();
            }}
          >
            &times;
          </button>
          <span className="CookieBanner-message">
            We use cookies to offer you a better experience.{' '}
            <a href="https://www.gosearch.ai/terms">Click here to see our terms of service.</a>
            <button
              type="button"
              tabIndex="0"
              className="CookieBanner-accept btn btn-opportunity CookieBanner-item"
              onClick={() => {
                this.handleAccept();
              }}
            >
              Accept Cookies
            </button>
          </span>
        </div>
      );
    }
    return null;
  }
}

export default CookieBanner;
